<template>
  <component :is="tag" ref="root" class="sp-cta-actions" flex>
    <slot />
  </component>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useDefaults } from "#ce/composables/useDefaults";

const root = useTemplateRef("root");
const props = defineProps({
  tag: {
    type: String,
    default: "sp-container",
  },
});

useDefaults(props, root, "SpCtaActions");
</script>
